import styled from 'styled-components'

export const ChatWrapper = styled.div`
  .str-chat__reaction-selector {
    background: white !important;
    box-shadow: white !important;
  }

  .str-chat__reaction-list--reverse::before {
    background: none !important;
  }
  .str-chat__reaction-list--reverse {
    background: none !important;
  }
  .str-chat__reaction-list--reverse::after {
    background: none !important;
  }

  .str-chat__textarea textarea {
    background-color: #fafafa !important;
  }
  .str-chat__input--emojipicker {
    right: 0 !important;
    left: auto !important;
  }
  .str-chat__message-team-form-footer {
    margin-top: 0px !important;
  }
  .str-chat__small-message-input-emojipicker {
    top: 96px !important;
    left: -114px !important;
  }
  .str-chat__modal__close-button {
    padding: 15px !important;
  }
  .str-chat__edit-message-form {
    width: 360px;
  }

  /* Enhanced Edit Message Modal */
  .str-chat__modal.str-chat__modal--open {
    background: rgba(0, 0, 0, 0.5) !important;
    backdrop-filter: blur(8px) !important;
  }

  .str-chat__modal__inner {
    width: 500px !important;
    max-width: 90vw !important;
    background: #ffffff !important;
    border-radius: 16px !important;
    box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.15) !important;
    padding: 0 !important;
    position: relative !important;
    overflow: hidden !important;
  }

  /* Modal Header */
  .str-chat__modal__inner::before {
    content: 'Editing message' !important;
    display: block !important;
    padding: 20px 24px 16px !important;
    font-weight: 600 !important;
    font-size: 16px !important;
    color: #121212 !important;
    border-bottom: 1px solid #e5e7eb !important;
    background: #ffffff !important;
  }

  .str-chat__edit-message-form {
    position: relative !important;
    top: 0 !important;
    padding: 20px 24px 24px !important;
    width: auto !important;
  }

  .str-chat__modal .str-chat__edit-message-form textarea {
    border: 1px solid #e5e7eb !important;
    height: auto !important;
    min-height: 80px !important;
    max-height: 200px !important;
    font-size: 14px !important;
    border-radius: 8px !important;
    padding: 12px 16px !important;
    background: #ffffff !important;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important;
    line-height: 1.5 !important;
    resize: vertical !important;
  }

  .str-chat__modal .str-chat__edit-message-form textarea:focus {
    border: 1px solid #705af8 !important;
    outline: none !important;
    box-shadow: 0 0 0 3px rgba(112, 90, 248, 0.1) !important;
  }

  .str-chat__modal .str-chat__message-team-form-footer {
    margin-top: 16px !important;
    display: flex !important;
    justify-content: flex-end !important;
    gap: 12px !important;
  }

  .str-chat__modal .str-chat__message-team-form-footer button {
    padding: 8px 16px !important;
    border-radius: 8px !important;
    border: none !important;
    font-weight: 500 !important;
    font-size: 14px !important;
    transition: all 0.2s ease !important;
    min-width: 80px !important;
    cursor: pointer !important;
  }

  /* Cancel Button */
  .str-chat__modal .str-chat__message-team-form-footer button:not([type='submit']) {
    background: #ffffff !important;
    color: #6b7280 !important;
    border: 1px solid #e5e7eb !important;
  }

  .str-chat__modal .str-chat__message-team-form-footer button:not([type='submit']):hover {
    background: #f9fafb !important;
    border-color: #d1d5db !important;
  }

  /* Save Button */
  .str-chat__modal .str-chat__message-team-form-footer button[type='submit'] {
    background: #705af8 !important;
    color: #ffffff !important;
    border: 1px solid #705af8 !important;
  }

  .str-chat__modal .str-chat__message-team-form-footer button[type='submit']:hover {
    background: #6559ae !important;
    border-color: #6559ae !important;
  }

  .str-chat__modal .str-chat__message-team-form-footer button[type='submit']:disabled {
    background: #e5e7eb !important;
    color: #9ca3af !important;
    border-color: #e5e7eb !important;
    cursor: not-allowed !important;
  }

  .str-chat__modal__close-button {
    position: absolute !important;
    top: 16px !important;
    right: 16px !important;
    width: 32px !important;
    height: 32px !important;
    border: none !important;
    background: transparent !important;
    cursor: pointer !important;
    border-radius: 6px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    transition: background 0.2s ease !important;
    z-index: 10 !important;
  }

  .str-chat__modal__close-button:hover {
    background: #f3f4f6 !important;
  }

  .str-chat__modal__close-button svg {
    width: 16px !important;
    height: 16px !important;
    fill: #6b7280 !important;
    margin: 0 !important;
    top: 0 !important;
  }

  .str-chat__modal__close-button:hover svg {
    fill: #374151 !important;
  }

  /* Dark mode support */
  .str-chat.dark .str-chat__modal__inner {
    background: #2e3033 !important;
    box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.3) !important;
  }

  .str-chat.dark .str-chat__modal__inner::before {
    color: #ffffff !important;
    background: #2e3033 !important;
    border-bottom-color: #4a4d55 !important;
  }

  .str-chat.dark .str-chat__modal .str-chat__edit-message-form textarea {
    background: #2e3033 !important;
    border-color: #4a4d55 !important;
    color: #ffffff !important;
  }

  .str-chat.dark .str-chat__modal__close-button:hover {
    background: #4a4d55 !important;
  }

  .str-chat.dark .str-chat__modal__close-button svg {
    fill: #ffffff !important;
  }

  /* Inline Edit Message Form Styling */
  .str-chat__message-input-wrapper .str-chat__textarea textarea {
    border: 1px solid #e5e7eb !important;
    border-radius: 8px !important;
    padding: 12px 16px !important;
    font-size: 14px !important;
    line-height: 1.5 !important;
    min-height: 80px !important;
    max-height: 200px !important;
    resize: vertical !important;
    background: white !important;
    transition: border-color 0.2s ease !important;
  }

  .str-chat__message-input-wrapper .str-chat__textarea textarea:focus {
    border-color: #705af8 !important;
    outline: none !important;
    box-shadow: 0 0 0 3px rgba(112, 90, 248, 0.1) !important;
  }

  .str-chat__message-input-wrapper .str-chat__message-team-form-footer {
    display: flex !important;
    justify-content: flex-end !important;
    gap: 12px !important;
    margin-top: 16px !important;
  }

  .str-chat__message-input-wrapper .str-chat__message-team-form-footer button {
    padding: 8px 16px !important;
    border-radius: 8px !important;
    font-weight: 500 !important;
    font-size: 14px !important;
    transition: all 0.2s ease !important;
    min-width: 80px !important;
    cursor: pointer !important;
    border: none !important;
  }

  /* Cancel Button in inline edit */
  .str-chat__message-input-wrapper .str-chat__message-team-form-footer button:not([type='submit']) {
    background: white !important;
    color: #6b7280 !important;
    border: 1px solid #e5e7eb !important;
  }

  .str-chat__message-input-wrapper
    .str-chat__message-team-form-footer
    button:not([type='submit']):hover {
    background: #f9fafb !important;
    border-color: #d1d5db !important;
  }

  /* Save Button in inline edit */
  .str-chat__message-input-wrapper .str-chat__message-team-form-footer button[type='submit'] {
    background: #705af8 !important;
    color: white !important;
    border: 1px solid #705af8 !important;
  }

  .str-chat__message-input-wrapper .str-chat__message-team-form-footer button[type='submit']:hover {
    background: #6559ae !important;
    border-color: #6559ae !important;
  }

  .str-chat__message-input-wrapper
    .str-chat__message-team-form-footer
    button[type='submit']:disabled {
    background: #e5e7eb !important;
    color: #9ca3af !important;
    border-color: #e5e7eb !important;
    cursor: not-allowed !important;
  }

  /* Hide unwanted elements in inline edit */
  .str-chat__message-input-wrapper .rfu-file-upload-button {
    display: none !important;
  }

  /* Mobile responsive */
  @media screen and (max-width: 640px) {
    .str-chat__modal.str-chat__modal--open {
      padding: 20px !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    }

    .str-chat__modal__inner {
      width: 100% !important;
      max-width: calc(100vw - 40px) !important;
      margin: 0 auto !important;
    }

    .str-chat__modal__inner::before {
      padding: 16px 20px 12px !important;
      font-size: 15px !important;
    }

    .str-chat__edit-message-form {
      padding: 16px 20px 20px !important;
    }

    .str-chat__modal .str-chat__edit-message-form textarea {
      min-height: 60px !important;
      max-height: 150px !important;
      padding: 10px 12px !important;
    }

    .str-chat__modal .str-chat__message-team-form-footer {
      margin-top: 14px !important;
    }

    .str-chat__modal .str-chat__message-team-form-footer button {
      padding: 10px 16px !important;
      font-size: 14px !important;
      min-width: 70px !important;
    }

    .str-chat__modal__close-button {
      top: 12px !important;
      right: 12px !important;
      width: 28px !important;
      height: 28px !important;
    }

    .str-chat__modal__close-button svg {
      width: 14px !important;
      height: 14px !important;
    }

    /* Mobile responsive for inline edit */
    .str-chat__message-input-wrapper .str-chat__textarea textarea {
      min-height: 60px !important;
      max-height: 150px !important;
      padding: 10px 12px !important;
    }

    .str-chat__message-input-wrapper .str-chat__message-team-form-footer button {
      padding: 10px 14px !important;
      font-size: 13px !important;
      min-width: 70px !important;
    }
  }

  /* Inline Edit Message Form Styling */
  .str-chat__message-simple-form .str-chat__message-input-wrapper textarea {
    border: 1px solid #e5e7eb !important;
    border-radius: 8px !important;
    padding: 12px 16px !important;
    font-size: 14px !important;
    line-height: 1.5 !important;
    min-height: 80px !important;
    background: #ffffff !important;
    transition: border-color 0.2s ease !important;
  }

  .str-chat__message-simple-form .str-chat__message-input-wrapper textarea:focus {
    border-color: #705af8 !important;
    outline: none !important;
    box-shadow: 0 0 0 3px rgba(112, 90, 248, 0.1) !important;
  }

  .str-chat__message-simple-form .str-chat__message-team-form-footer {
    display: flex !important;
    justify-content: flex-end !important;
    gap: 12px !important;
    margin-top: 16px !important;
  }

  .str-chat__message-simple-form .str-chat__message-team-form-footer button {
    padding: 8px 16px !important;
    border-radius: 8px !important;
    font-weight: 500 !important;
    font-size: 14px !important;
    transition: all 0.2s ease !important;
    min-width: 80px !important;
    cursor: pointer !important;
    border: none !important;
  }

  .str-chat__message-simple-form .str-chat__message-team-form-footer button:not([type='submit']) {
    background: #ffffff !important;
    color: #6b7280 !important;
    border: 1px solid #e5e7eb !important;
  }

  .str-chat__message-simple-form
    .str-chat__message-team-form-footer
    button:not([type='submit']):hover {
    background: #f9fafb !important;
    border-color: #d1d5db !important;
  }

  .str-chat__message-simple-form .str-chat__message-team-form-footer button[type='submit'] {
    background: #705af8 !important;
    color: #ffffff !important;
    border: 1px solid #705af8 !important;
  }

  .str-chat__message-simple-form .str-chat__message-team-form-footer button[type='submit']:hover {
    background: #6559ae !important;
    border-color: #6559ae !important;
  }

  .str-chat__message-simple__actions__action--thread {
    display: none !important;
  }

  /* Hide default Stream Chat reply count components */
  .str-chat__message-replies-count-button,
  .str-chat__message-replies-count,
  .str-chat__message__reply-count,
  .str-chat__message-simple__reply-count,
  .str-chat__message-replies-count-button:before,
  .str-chat__message-replies-count:before,
  .str-chat__message__reply-count:before,
  .str-chat__message-simple__reply-count:before {
    display: none !important;
  }

  /* Thread indicator styling */
  .thread-indicator-badge {
    background: rgba(219, 219, 219, 1) !important; /* app-grey-40 */
    color: rgba(79, 79, 79, 1) !important; /* app-grey-80 */
    border-radius: 50% !important;
    width: 24px !important;
    height: 24px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    font-size: 10px !important;
    font-weight: 600 !important;
    transition: all 0.2s ease !important;
  }

  .thread-indicator-badge:hover {
    background: rgba(165, 165, 165, 1) !important; /* app-grey-50 */
    color: rgba(56, 56, 56, 1) !important; /* app-grey-90 */
  }

  .thread-replies-button {
    background: transparent !important;
    border: none !important;
    padding: 8px 12px !important;
    border-radius: 8px !important;
    transition: background-color 0.2s ease !important;
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
  }

  .thread-replies-button:hover {
    background: rgba(249, 249, 249, 1) !important; /* app-grey-5 */
  }

  /* Dark mode support for thread indicators */
  .str-chat.dark .thread-indicator-badge {
    background: rgba(79, 79, 79, 1) !important; /* app-grey-80 */
    color: rgba(219, 219, 219, 1) !important; /* app-grey-40 */
  }

  .str-chat.dark .thread-indicator-badge:hover {
    background: rgba(94, 94, 94, 1) !important; /* app-grey-70 */
    color: rgba(245, 245, 245, 1) !important; /* app-grey-20 */
  }

  .str-chat.dark .thread-replies-button:hover {
    background: rgba(42, 42, 42, 1) !important; /* app-grey-100 */
  }

  /* Slack-like Thread Layout */
  .str-chat__main-panel {
    display: flex !important;
    flex: 1 !important;
    transition: width 0.3s ease !important;
    width: 100% !important;
    padding: 20px !important;
  }

  .str-chat__main-panel--thread-open {
    width: 60% !important;
    min-width: 400px !important;
  }

  .str-chat__thread {
    width: 40% !important;
    min-width: 320px !important;
    max-width: 500px !important;
    position: relative !important;
    display: block !important;
    border-left: 1px solid rgba(236, 236, 236, 1) !important; /* app-grey-30 */
    background: rgba(255, 255, 255, 1) !important; /* app-white-100 */
    flex-shrink: 0 !important;
    z-index: 1000 !important; /* ENSURE IT'S VISIBLE */
  }

  /* Ensure thread header is always visible when thread is open */
  .str-chat__thread .custom-thread-header {
    display: flex !important;
    visibility: visible !important;
    height: 60px !important;
    min-height: 60px !important;
    flex-shrink: 0 !important;
    position: relative !important;
    z-index: 10 !important;
  }

  /* Ensure thread container has proper flex layout */
  .str-chat__thread-container {
    display: flex !important;
    flex-direction: column !important;
    height: 100% !important;
  }

  .str-chat.dark .str-chat__thread {
    border-left: 1px solid rgba(56, 56, 56, 1) !important; /* app-grey-90 */
    background: rgba(42, 42, 42, 1) !important; /* app-grey-100 */
  }

  /* Ensure thread doesn't overlay - REMOVED FOR DEBUGGING */
  /* .str-chat__thread:not(.str-chat__thread--open) {
    display: none !important;
  } */

  /* Mobile responsive for thread layout */
  @media screen and (max-width: 768px) {
    .str-chat__main-panel--thread-open {
      width: 100% !important;
      display: none !important;
    }
    
    .str-chat__thread {
      width: 100% !important;
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      right: 0 !important;
      bottom: 0 !important;
      z-index: 1000 !important;
      max-width: none !important;
    }
  }
  .str-chat__li--bottom {
    margin: 0px !important;
  }
  .str-chat__li--top {
    margin: 0px !important;
  }
  .str-chat__modal {
    left: 0;
  }
  .str-chat__list {
    padding-top: 0 !important;
  }
  .str-chat__modal .str-chat__edit-message-form textarea {
    max-height: fit-content !important;
  }
  p {
    font-family: 'Futura Std' !important;
  }

  .str-chat__message--me .str-chat__message-text-inner,
  .str-chat__message-simple--me .str-chat__message-text-inner {
    border-radius: 10px 10px 0px 10px !important;
  }
  .str-chat__message-text-inner,
  .str-chat__message-simple-text-inner {
    border-radius: 0px 10px 10px 10px;
  }
  .str-chat__message-text-inner {
    font-weight: 500;
  }

  .str-chat__message-text-inner p {
    font-weight: 500;
  }

  @media screen and (min-device-width: 400px) and (max-device-width: 500px) and (min-device-height: 700px) and (max-device-height: 900px) {
    .str-chat-channel {
      height: calc(100% - 55px) !important;
    }
    .str-chat__list {
      max-height: calc(100vh - 242px);
    }
  }
  @media screen and (min-device-width: 350px) and (max-device-width: 400px) and (min-device-height: 700px) and (max-device-height: 900px) {
    .str-chat-channel {
      height: calc(100% - 55px) !important;
    }
    .str-chat__list {
      max-height: calc(100vh - 245px);
    }
    .str-chat__modal.str-chat__modal--open {
      padding: 0;
    }
  }
  @media screen and (max-device-width: 400px) and (max-device-height: 700px) {
    .str-chat-channel {
      height: 91vh !important;
    }
  }
  @media screen and(min-device-width: 400px) and(max-device-width: 500px) and (min-device-height: 700px) and (max-device-height: 900px) {
    .str-chat-channel {
      height: 92vh !important;
    }
  }
  @media only screen and (min-device-width: 500px) and (max-device-width: 1000px) {
    .str-chat-channel {
      height: 100% !important;
    }
    .messaging.str-chat .str-chat__list {
      max-height: calc(100% - 200px);
    }
  }
  @media screen and (max-device-width: 400px) and (max-device-height: 700px) {
    .str-chat-channel {
      box-shadow: none !important;
      height: 91vh !important;
    }
    .str-chat-channel-list {
      box-shadow: none !important;
      height: 71vh !important;
    }
  }

  @media only screen and (min-device-width: 1000px) and (max-device-width: 1299px) {
    .str-chat {
      height: 76vh !important;
      overflow-y: auto;
    }
    .str-chat-channel {
      box-shadow: none !important;
      height: 83vh !important;
    }
  }

  @media only screen and (min-device-width: 1400px) {
    .str-chat {
      height: 66vh !important;
      overflow-y: auto;
    }
    .str-chat-channel {
      box-shadow: none !important;
      height: 73vh !important;
    }
  }

  @media only screen and (min-device-width: 1000px) and (max-device-width: 1100px) and (min-device-height: 700px) and (max-device-height: 900px) {
    .str-chat {
      height: 48vh !important;
      overflow-y: auto;
    }
    .str-chat-channel {
      box-shadow: none !important;
      height: 70vh !important;
    }
  }
  @media only screen and (min-device-width: 1299px) and (max-device-width: 1399px) {
    .str-chat {
      height: 61vh !important;
      overflow-y: auto;
    }
    .str-chat-channel {
      box-shadow: none !important;
      height: 77vh !important;
    }
  }
`
